import PhotoSwipeLightbox from 'https://cdnjs.cloudflare.com/ajax/libs/photoswipe/5.3.8/photoswipe-lightbox.esm.min.js';

const lightboxProd = new PhotoSwipeLightbox({
  gallery: '.swiper-prod',
  children: 'a',
  pswpModule: () =>
    import(
      "https://cdnjs.cloudflare.com/ajax/libs/photoswipe/5.3.8/photoswipe.esm.min.js"
    ),
  bgOpacity: 0.5,
  padding: { top: 30, bottom: 30, left: 0, right: 0 },
  showHideOpacity: true,
  preload: [ 2, 5 ]
});
lightboxProd.init();
